import { useMutation } from '@apollo/client'
import { DeleteEvent, DeleteEventVariables } from '../../types'
import { DELETE_EVENT } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useDeleteEvent = ({ onCompleted }: Props) =>
  useMutation<DeleteEvent, DeleteEventVariables>(DELETE_EVENT, {
    onCompleted,
  })
